export default __webpack_public_path__ + "static/media/bg6.6e4dc005.png";